export default "__VITE_ASSET__a3c9c3da__"